import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from '../services/rest.service';
@Injectable({
  providedIn: 'root'
})
export class DriverService {

  constructor(private restHttp: RestService) { }

  public getAllDriversByCityId(cityId): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllDriversByCityId?cityId=${cityId}`);
  }
  public assignBatchToDriver (batchId, driverId) : Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AssignBatchToDriver/${driverId}?batchId=${batchId}`);

  }
  public DeleteDriver(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteDriver?driverId=${id}`);
  }
  public SignUpDriver(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/Driver`, model);
  }
  getDriverbyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Driver/${id}`);
  }
  public GETOrderHistory(driverId: number, date: Date, date1: Date): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`
    ${this.restHttp.serverURL}/DriverOrderHistory?driverId=${driverId}&fromDate=${date1}&toDate=${date}`);
  }
  public GETOrderDetailByOrderId(orderId): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/OrderDetail?orderId=${orderId}`);
  }
  public GETDriverFeedack(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Feedback?driverId=${id}`);
  }
}
